<template>
    <div>
        <v-dialog
            v-model="projectDataDialog"
            transition="scale-transition"
            origin="center center"
            fullscreen
            style="z-index: 2000">
            <v-card class="d-flex align-start">
                <div style="width: 100%">
                    <ProjectDetails
                        :user_id="this_userId"
                        :project_id="this_projectId"
                        :client_info="this_clientInfo"
                        :project_statuses="projectStatusData"
                        openTab="report"
                        @closeDetailDialog="closeDetailDialog" />
                </div>
            </v-card>
        </v-dialog>

        <v-navigation-drawer
            v-model="projectTaskDialog"
            temporary
            absolute
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card flat class="drawer-content">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                        {{ dialogTitle('projectTaskDialog') }}
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="closeNavigationDrawer('projectTaskDialog')">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="pt-3 px-3 mx-0">
                    <ProjectReportDialog
                        :editedItem="editedItem"
                        :formatThisDate="formatThisDate"
                        @save="save"
                        @next-task="loadNextTask"
                        @close="close" />
                </v-card-text>
            </v-card>
        </v-navigation-drawer>

        <div id="tasks_wrapper">
            <div>
                <div class="pt-8 d-flex">
                    <div class="sansation info--text d-inline mx-4"><h2>Tasks Dashboard</h2></div>
                </div>

                <div class="pt-0 pb-4 px-2 justify-space-between" flat>
                    <div class="d-flex d-block justify-space-between">
                        <div class="d-inline mb-7" style="min-width: 25%">
                            <v-text-field 
                                v-model="search"
                                hint="Search for an existing task by name, project title, client name, etc."
                                persistent-hint 
                                single-line 
                                color="primary darken-1" 
                                append-icon="mdi-magnify"
                                class="ml-2 mr-6">
                            </v-text-field>
                            <!-- COMPLETED TASKS ARE ONLY PULLED WHEN ASKED FOR, SO THE DASHBOARD LOADS FAST -->
                            <v-switch
                                v-model="filterby.completed_only"
                                label="Completed Tasks Only"
                                @change="toggleCompletedOnly()"
                                hide-details
                                class="ml-2 mt-6">
                            </v-switch>
                            <!-- COMPLETED TASKS ARE PULLED FOR A DATE RANGE (DEFAULT: LAST 30 DAYS) -->
                            <v-menu
                                v-if="filterby.completed_only"
                                v-model="completedDateRangeMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="completedDateRangeText"
                                        label="Completed Date Range"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        hide-details
                                        class="ml-2 mt-4"
                                        style="max-width: 300px"
                                        color="primary darken-1">
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="completedDateRangeDraft"
                                    range
                                    no-title
                                    scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="completedDateRangeMenu = false">Cancel</v-btn>
                                    <v-btn text color="primary" :disabled="completedDateRangeDraft.length !== 2" @click="applyCompletedDateRange()">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </div>
                        <div class="d-inline mt-3 mb-4">
                            <div class="d-flex d-block justify-space-between mb-2">
                                <div class="d-inline">
                                    <v-autocomplete 
                                        v-model="filterby.status"
                                        :items="openTaskStatusArray" 
                                        label="Task Status" 
                                        multiple
                                        :disabled="filterby.completed_only"
                                        :rules="filterby.completed_only ? [] : taskStatusRules"
                                        class="mt-n1 mx-3" 
                                        color="primary darken-1"
                                        ref="statusAutocomplete"
                                        @change="filterTasks()">
                                    </v-autocomplete>
                                </div>
                                <div class="d-inline">
                                    <v-autocomplete 
                                        v-model="filterby.priority"
                                        :items="priorityArray" 
                                        label="Priority" 
                                        hide-details 
                                        multiple
                                        class="mt-n1 mx-3" 
                                        color="primary darken-1"
                                        @change="filterTasks()">
                                    </v-autocomplete>
                                </div>
                                <div class="d-inline">
                                    <v-autocomplete 
                                        v-model="filterby.owner"
                                        :items="ownerArray" 
                                        label="Owner" 
                                        hide-details 
                                        multiple
                                        class="mt-n1 mx-3" 
                                        color="primary darken-1"
                                        @change="filterTasks()">
                                    </v-autocomplete>
                                </div>
                                <div class="d-inline">
                                    <v-autocomplete 
                                        v-model="filterby.due_date"
                                        :items="due_date_filter" 
                                        label="Due Date" 
                                        hide-details 
                                        multiple
                                        class="mt-n1 mx-3" 
                                        color="primary darken-1"
                                        @change="filterTasks()">
                                    </v-autocomplete>
                                </div>
                            </div>
                            <div class="d-flex d-block justify-space-between mt-4">
                                <div class="d-inline flex-grow-1">
                                    <v-autocomplete 
                                        v-model="filterby.module"
                                        :items="services" 
                                        label="Service(s)" 
                                        hide-details 
                                        multiple
                                        class="mt-n1 mx-3" 
                                        color="primary darken-1"
                                        @change="filterTasks()">
                                    </v-autocomplete>
                                </div>
                                <!-- <div class="d-inline">
                                    <v-autocomplete 
                                        v-model="filterby.service_levels"
                                        :items="service_levels" 
                                        label="Service Level(s)" 
                                        hide-details 
                                        multiple
                                        class="mt-n1 mx-3" 
                                        color="primary darken-1"
                                        @change="filterTasks()">
                                            <template v-slot:message="{ message }">
                                                <span v-html="message"></span>
                                            </template>
                                    </v-autocomplete>
                                </div> -->
                                <div class="d-inline">
                                    <v-autocomplete 
                                        v-model="filterby.project_status"
                                        :items="projectStatusArray" 
                                        label="Project Status" 
                                        hide-details 
                                        multiple
                                        class="mt-n1 mx-3" 
                                        color="primary darken-1"
                                        @change="filterTasks()">
                                    </v-autocomplete>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex d-block justify-end align-center pr-2">
                        <span v-if="filterby.completed_only && completed_info.truncated" class="warning--text text--darken-2 mr-4">
                            Showing the {{ completed_info.shown.toLocaleString() }} most recently completed of {{ completed_info.completed_total.toLocaleString() }} tasks in this range - narrow the Completed Date Range to see the rest.
                        </span>
                        <template v-if="filtered_tasks_cnt">
                            <div class="d-inline justify-end">
                                {{ filtered_tasks_cnt }} total results
                            </div>
                            <v-divider vertical class="mx-4" />
                            <div class="d-inline justify-end">
                                {{ totalFilteredTasksDuration }} hours
                            </div>
                        </template>
                        <v-btn
                            v-if="hasActiveFilters"
                            x-small
                            text
                            color="primary darken-1"
                            class="ml-3"
                            @click="clearFilters()">
                            Clear Filters
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-data-table
                :headers="headers"
                :items="searchedTasks"
                :loading="table_loading"
                loading-text="Pulling tasks ..."
                :options.sync="options"
                @update:options="onUpdateOptions"
                :footer-props="{ 'items-per-page-options': PAGE_SIZE_OPTIONS }"
                fixed-header
                :height="'calc(100vh - 380px)'"
                class="custom-table"
            >
                <template v-slot:no-data>
                    <div class="text-center pt-12">
                        <v-icon large>{{ effectiveStatuses.length == 0 ? `mdi-alert` : `mdi-alert-circle` }}</v-icon>
                        <p class="mt-2">{{ effectiveStatuses.length == 0 ? `Task Status is required to gather new tasks!` : `No tasks found matching your filters.` }}</p>
                    </div>
                </template>

                <template v-slot:no-results>
                    <div class="text-center pt-12">
                        <v-icon large>mdi-alert-circle</v-icon>
                        <p class="mt-2">No tasks found matching your filters.</p>
                    </div>
                </template>

                <template v-slot:item="{ item }">
                    <tr :key="item.task_id"
                        class="d-table-row">

                        <!-- Project Related Columns -->
                        <td 
                            class="task_data_class text-start"
                            style="padding: 9px .2em !important"
                            @click.stop="openTaskDetails( item )">
                            <UserData_Dashboard 
                                :user_data="item.client_info"
                                source="server" 
                            />
                        </td>
                        <td class="task_data_class text-start" 
                            @click.stop="openTaskDetails( item )">

                            <div v-html="item.project_label"></div>
                            <div class="d-block" v-if="item.multi_project">
                                <v-chip 
                                    x-small
                                    label
                                    class="font-weight-bold"
                                    text-color="white" 
                                    color="primary lighten-2">
                                    multi-service project
                                </v-chip>
                            </div>
                            <div class="d-block">
                                Status: 
                                <span :class="item.project_status_text_color">
                                    <strong>{{ item.project_status_label }}</strong>
                                </span>
                            </div>
                            <div class="d-block" v-if="item.is_archived">
                                <v-chip 
                                    x-small
                                    label
                                    class="font-weight-bold"
                                    text-color="white" 
                                    color="grey lighten-1">
                                    Archived
                                </v-chip>
                            </div>
                        </td>
                        <!-- Task Related Columns -->
                        <td class="task_data_class text-start align-center left-border-cell"
                            style="padding-left: .3em !important"
                            @click="openTaskDetailsDialog(item)">
                            {{ item.label }}
                        </td>
                        <td class="task_data_class text-end"
                            style="padding-right: 1em !important" 
                            @click="openTaskDetailsDialog(item)">
                            {{ labels[`step_status_${item.status}`] }}
                        </td>
                        <td class="task_data_class text-start" 
                            @click="openTaskDetailsDialog(item)">
                            {{ labels[`step_priority_${item.priority}`] }}
                        </td>
                        <td class="task_data_class text-start" 
                            @click="openTaskDetailsDialog(item)">
                            {{ labels[`step_complexity_${item.complexity}`] }}
                        </td>
                        <td class="task_data_class text-start" 
                            @click="openTaskDetailsDialog(item)">
                            {{ item.owner_id ? ownerItems[item.owner_id] : '' }}
                        </td>
                        <td class="task_data_class text-start" 
                            @click="openTaskDetailsDialog(item)">
                            <v-icon 
                                class="ml-2"
                                :color="item.internal ? 'primary' : 'error'"
                                :title="item.internal ? 'Internal Only' : 'External'">
                                {{ item.internal ? 'mdi-check' : 'mdi-close' }}
                            </v-icon>
                        </td>
                        <td class="task_data_class text-start" 
                            @click="openTaskDetailsDialog(item)">
                            <div class="ml-2">{{ item.duration }}</div>
                        </td>
                        <td class="task_data_class text-start" 
                            @click="openTaskDetailsDialog(item)" v-html="item.due_date_label">
                        </td>
                        <td class="task_data_class text-start" 
                            @click="openTaskDetailsDialog(item)">
                            {{ formatThisDate(item.assigned_date) }}
                        </td>
                        <td class="task_data_class text-start first-last-column-padding" 
                            @click="openTaskDetailsDialog(item)">
                            {{ formatThisDate(item.completed_date) }}
                        </td>
                    </tr>
                    <!-- </tbody> -->
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment'
    import { safeParseJson } from '../helpers/safe-json'
    import { searchTableRows } from '../helpers/tableSearch'
    import { dataTimeDisplayFormatter } from './utilities'

    import { 
        moduleServices,
        serviceLevels,
        complexityItems,
        durationItems,
        ownerItems,
        priorityItems,
        taskStatusItems, 
        responsiblePartyItems
    } from '../helpers/constants'
    import ProjectDetails from './ProjectDetails'
    import UserData_Dashboard from './UserData_Dashboard.vue'
    import ProjectReportDialog from './ProjectReportDialog.vue';

    const PAGE_SIZE_OPTIONS = [25, 50, 100]
    const DEFAULT_PAGE_SIZE = 50

    export default {
        name: 'Task_Dashboard',

        components: {
            ProjectDetails,
            UserData_Dashboard,
            ProjectReportDialog
        },

        data () {
            return {
                search: '',
                filterby: {
                    module: [],
                    // service_levels: [],
                    status: [],
                    priority: [],
                    owner: [],
                    due_date: [],
                    project_status: [],
                    completed_only: false,
                    completed_date_range: [],
                    search: ''
                },
                completedDateRangeMenu: false,
                completedDateRangeDraft: [],
                completed_info: { truncated: false, completed_total: 0, shown: 0 },
                // PAGED SO THE TABLE ONLY RENDERS ONE PAGE OF ROWS AT A TIME
                options: {
                    sortBy: ['date'],
                    sortDesc: [false],
                    itemsPerPage: DEFAULT_PAGE_SIZE,
                    multiSort: true
                },
                PAGE_SIZE_OPTIONS,
                headers: [
                    { text: "Client Name(s)",       value: "client_info_stringified", align: 'start', sortable: true,  width: '220px' },
                    { text: "Project Info",         value: "project_label",           align: 'start', sortable: true,  width: '220px' },
                    { text: "Task",                 value: "label",                   align: 'start', sortable: true,  width: '270px' },
                    { text: "Status",               value: "status",                  align: 'end',   sortable: true,  width: '90px' },
                    { text: "Priority",             value: "priority",                align: 'start', sortable: true,  width: '150px' },
                    { text: "Complexity",           value: "complexity_val",          align: 'start', sortable: true,  width: '105px' },
                    { text: "Owner",                value: "owner_name",              align: 'start', sortable: true,  width: '115px' },
                    { text: "Internal",             value: "internal",                align: 'start', sortable: true,  width: '80px' },
                    { text: "Duration",             value: "duration",                align: 'start', sortable: true,  width: '85px' },
                    { text: "Due Date",             value: "date",                    align: 'start', sortable: true,  width: '90px' },
                    { text: "Assigned Date",        value: "assigned_date",           align: 'start', sortable: true,  width: '110px' },
                    { text: "Completed Date",       value: "completed_date",          align: 'start', sortable: true,  width: '120px' },
                ],
                services: moduleServices,
                // service_levels: serviceLevels,
                due_date_filter: [
                    { id: 1, text: 'Past Due',       value: 'past_due' },
                    { id: 2, text: 'Due Today',      value: 'due_today' },
                    { id: 3, text: 'Due Tomorrow',   value: 'due_tomorrow' },
                    { id: 4, text: 'Due This Week',  value: 'due_this_week' },
                    { id: 5, text: 'Due This Month', value: 'due_this_month' },
                ],
                modules: [],
                tasks: [],
                table_loading: false,
                searched_status_filters: [],
                filteredTasks: [],
                filtered_tasks_cnt: 0,
                editedItem: {},
                debounceTimeout: null,
                labels: {
                    tab_steps: 'Project Steps',
                    tab_meetings: 'Meetings',
                    
                    step_status_not_started: 'Not Started',
                    step_status_on_deck: 'On Deck',
                    step_status_scheduled: 'Scheduled',
                    step_status_in_progress: 'In Progress',
                    step_status_completed: 'Completed',
                    step_status_not_applicable: 'Not Applicable',

                    step_complexity_low: 'Low',
                    step_complexity_medium: 'Medium',
                    step_complexity_high: 'High',

                    step_priority_normal: 'Normal',
                    step_priority_urgent: 'Urgent',
                    step_priority_backburner: 'Back Burner',
                    step_priority_annual: 'Annual',
                },
                responsiblePartyItems: responsiblePartyItems,
                statusItems: taskStatusItems,
                priorityItems: priorityItems,
                complexityItems: complexityItems,
                ownerItems: ownerItems,
                projectStatusData: [],
                projectDataDialog: false,
                this_userId: '',
                this_projectId: '',
                this_clientInfo: [],
                users_sortorder: ['owner', 'secondary', 'partner'],
                projectTaskDialog: false,
                taskStatusRules: [
                    (v) => (v && v.length > 0) || 'Task Status is required to gather new tasks'
                ]
            }
        },
        
        computed: {
            // EVERY TASK MATCHING THE FILTERS + SEARCH (THE TABLE ONLY RENDERS THE CURRENT PAGE OF THESE)
            searchedTasks () {
                return searchTableRows(this.filteredTasks, this.headers, this.search)
            },
            complexityList () {
                return Object.keys(complexityItems).map(key => ({ value: key, text: complexityItems[key]}));
            },

            durationList () {
                return Object.keys(durationItems).map(key => ({ value: key, text: durationItems[key]}));
            },

            item () {
                const { item = {} } = this.editedItem;

                return {
                    ...item,
                    status: item.status || 'not_started'
                };
            }, 

            ownerList: function () {
                return Object.keys(ownerItems).map(key => ({ text: ownerItems[key] , value: key}));
            },

            ownerArray: function () {
                return Object.entries(ownerItems).map(([key, value]) => (
                    {
                        value: key,
                        text: value,
                    }
                ))
            },

            priorityList () {
                return Object.keys(priorityItems).map(key => ({ value: key, text: priorityItems[key]}));
            },

            priorityArray () {
                return Object.entries(priorityItems).map(([key, value]) => (
                    {
                        value: key,
                        text: value,
                    }
                ))
            },

            taskStatusList () {
                return Object.keys(taskStatusItems).map(key => ({ value: key, text: taskStatusItems[key]}));
            },

            // THE STATUSES ACTUALLY PULLED & SHOWN: ONLY "completed" WITH THE SWITCH ON, OTHERWISE THE CHOSEN OPEN STATUSES
            effectiveStatuses () {
                if ( this.filterby.completed_only ) return ['completed']
                return (this.filterby.status || []).filter(status => status !== 'completed')
            },

            completedDateRangeText () {
                const range = this.filterby.completed_date_range || []
                return range.length === 2 ? [...range].sort().join(' ~ ') : ''
            },

            // STATUS FILTER CHOICES (COMPLETED TASKS HAVE THEIR OWN SWITCH)
            openTaskStatusArray () {
                return this.taskStatusArray.filter(status => status.value !== 'completed')
            },

            taskStatusArray () {
                return Object.entries(taskStatusItems).map(([key, value]) => (
                    {
                        value: key,
                        text: value,
                    }
                ))
            },

            projectStatusArray () {
                return this.projectStatusData.map( status => (
                    {
                        value: status.value,
                        text: status.internal_label
                    }
                ))
            },

            // True when the filters differ from the default dashboard view
            hasActiveFilters () {
                const normalize = filters => JSON.stringify(Object.keys(filters).sort().map( key => {
                    const value = filters[key]
                    return [key, Array.isArray(value) ? [...value].sort() : value]
                }))
                return normalize({ ...this.filterby, search: this.search || '' }) !== normalize(this.defaultFilters())
            },

            totalFilteredTasksDuration () {
                return this.filteredTasks.reduce((total, task) => {
                    const duration = parseFloat(task.duration) || 0; // Ensure duration is a number
                    return total + duration;
                }, 0);
            }

        },

        watch: {
            completedDateRangeMenu (open) {
                if ( open ) this.completedDateRangeDraft = [...(this.filterby.completed_date_range || [])]
            },
            searchedTasks (rows) {
                this.filtered_tasks_cnt = rows.length
            },
            search(val) {
                this.filterby.search = val;
                localStorage.setItem('taskDashboardFilters', JSON.stringify(this.filterby));
                this.filterTasks();
            },

            'filterby.status': {
                handler (val) {
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = setTimeout(() => {
                        if ( !this.effectiveStatuses.every(item => this.searched_status_filters.includes(item)) ) {
                            this.table_loading = true;
                            this.filteredTasks = []
                            this.filtered_tasks_cnt = 0
                            this.getTasks()
                        }
                    }, 2000)
                }, immediate: true
            }
        },

        created () {
            this.getStatusData()

            const savedOptions = localStorage.getItem('taskDashboardOptions');
            if (savedOptions) {
                const parsedOptions = safeParseJson(savedOptions, null)
                if (parsedOptions && typeof parsedOptions === 'object') {
                    // OLDER SAVED OPTIONS SHOWED EVERY ROW (-1); START THOSE ON A NORMAL PAGE SIZE
                    this.options = {
                        ...parsedOptions,
                        page: 1,
                        itemsPerPage: PAGE_SIZE_OPTIONS.includes(parsedOptions.itemsPerPage) ? parsedOptions.itemsPerPage : DEFAULT_PAGE_SIZE
                    }
                }
            }

            const savedFilters = localStorage.getItem('taskDashboardFilters');
            if (savedFilters) {
                const parsedFilters = safeParseJson(savedFilters, null)
                if (parsedFilters && typeof parsedFilters === 'object') {
                    this.filterby = parsedFilters
                }
                this.filterby.due_date = this.filterby.due_date ? this.filterby.due_date : []
                this.filterby.project_status = this.filterby.project_status ? this.filterby.project_status : ['open', 'review', 'processing']
                this.$set(this.filterby, 'completed_only', this.filterby.completed_only === true)
                this.$set(this.filterby, 'completed_date_range', Array.isArray(this.filterby.completed_date_range) && this.filterby.completed_date_range.length === 2 ? this.filterby.completed_date_range : [])
                this.filterby.status = (this.filterby.status || []).filter(status => status !== 'completed')
                this.search = this.filterby.search;
            } else {
                this.initializeTaskFilters()
            }

            this.table_loading = true;
            this.getTasks();
        },

        mounted() {
            // Wait for the DOM to update, then manually trigger the validation function
            this.$nextTick(() => {
                if (this.$refs.statusAutocomplete) {
                    // This forces the component to check its rules, even if nothing has changed
                    this.$refs.statusAutocomplete.validate(true); 
                }
            });
        },
        
        methods: {
            dialogTitle ( drawer ) {
                if (drawer === 'projectReportStepDialog') {
                    return 'Create a new Milestone';
                } else if (drawer === 'projectTaskDialog') {
                    return this.editedItem.task_id ? 'Edit Task' : 'Add Task';
                } else if (drawer === 'projectReportMeetingDialog' || drawer === 'calendlyDialog') {
                    return 'Schedule a Meeting';
                } else if (drawer === 'reorderTasksDialog') {
                    return 'Reorder Tasks';

                }
            },

            closeNavigationDrawer( drawer ) {
                if (drawer === 'projectReportStepDialog') {
                    this.projectReportStepDialog = false;
                } else if (drawer === 'projectTaskDialog') {
                    this.projectTaskDialog = false;
                } else if (drawer === 'projectReportMeetingDialog') {
                    this.projectReportMeetingDialog = false;
                } else if (drawer === 'calendlyDialog') {
                    this.closeCalendly();
                } else if (drawer === 'reorderTasksDialog') {
                    this.reorderTasksDialog = false;
                }
            },

            defaultFilters: function () {
                return {
                    module: [],
                    status: ['not_started', 'on_deck', 'scheduled', 'in_progress'],
                    priority: [],
                    owner: [],
                    due_date: [],
                    project_status: ['open', 'review', 'processing'],
                    completed_only: false,
                    completed_date_range: [],
                    search: ''
                }
            },

            // Reset back to the default dashboard view (same as a first visit)
            clearFilters: function () {
                const was_completed_only = this.filterby.completed_only
                this.search = ''
                this.filterby = this.defaultFilters()
                localStorage.setItem('taskDashboardFilters', JSON.stringify(this.filterby))
                // LEAVING "COMPLETED TASKS ONLY" MEANS THE OPEN TASKS HAVE TO BE PULLED AGAIN
                if ( was_completed_only ) return this.toggleCompletedOnly()
                // The filterby.status watcher re-pulls tasks if the default statuses weren't already loaded
                this.filterTasks()
            },

            initializeTaskFilters: function () {
                // const admin_modules = this.services.filter(service => this.admin_matches.includes(service.id))
                // this.filterby.module = admin_modules.map(service => service.value)
                // this.filterby.service_levels = ['starter', 'premium', 'elite', 'lite']
                this.filterby.due_date = []
                this.filterby.project_status = ['open', 'review', 'processing']
                this.filterby.status = ['not_started', 'on_deck', 'scheduled', 'in_progress']
                this.filterby.completed_only = false
                this.filterby.search = this.search

                localStorage.setItem('taskDashboardFilters', JSON.stringify(this.filterby))
            },

            getStatusData: async function () {
                try {
                    const get_project_status_data = await axios.get(`${appUrls.api}/api/project_status_data`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    this.projectStatusData = get_project_status_data.data.status_data
                } catch ( error ) {
                    console.log(error);
                }
            },

            formatThisDate: function ( date, options, iso_format=false ) {
                if (!date) return '';

                const defaultOptions = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }
                return dataTimeDisplayFormatter(date, options ? options : defaultOptions, iso_format )
            },

            isPastDue ( date ) {
                const givenDate = new Date(date).toISOString().split('T')[0]
                const today = new Date().toISOString().split('T')[0]

                const givenDateMilliseconds = new Date(givenDate).getTime()
                const todayMilliseconds = new Date(today).getTime()

                return givenDateMilliseconds < todayMilliseconds
            },

            isToday ( date ) {
                const givenDate = new Date(date).toISOString().split('T')[0]
                const today = new Date().toISOString().split('T')[0]

                const givenDateMilliseconds = new Date(givenDate).getTime()
                const todayMilliseconds = new Date(today).getTime()

                return todayMilliseconds === givenDateMilliseconds
            },

            isTomorrow ( date ) {
                const givenDate = new Date(date).toISOString().split('T')[0]
                let tomorrow = new Date().toISOString().split('T')[0]
                tomorrow = new Date(tomorrow)
                tomorrow.setDate(tomorrow.getDate() + 1) // Move to tomorrow

                const givenDateMilliseconds = new Date(givenDate).getTime()
                const tomorrowMilliseconds = tomorrow.getTime()

                return tomorrowMilliseconds === givenDateMilliseconds
            },

            isInSameWeek ( date ) {
                let now = new Date()
                // console.log('--- now ---', now)

                let startOfWeek = new Date(now)
                startOfWeek.setDate(now.getDate() - now.getDay()) // Start of the week (Sunday)
                startOfWeek.setHours(0, 0, 0, 0)

                let endOfWeek = new Date(startOfWeek)
                endOfWeek.setDate(startOfWeek.getDate() + 6) // End of the week (Saturday)

                // RESET DATES WITHOUT TIME
                now = new Date().toISOString().split('T')[0]
                startOfWeek = startOfWeek.toISOString().split('T')[0]
                endOfWeek = endOfWeek.toISOString().split('T')[0]
                const givenDate = new Date(date).toISOString().split('T')[0]

                // CONVERT TO MILLISECONDS
                const givenDateMilliseconds = new Date(givenDate).getTime()
                const startOfWeekMilliseconds = new Date(startOfWeek).getTime()
                const endOfWeekMilliseconds = new Date(endOfWeek).getTime()
             
                return givenDateMilliseconds >= startOfWeekMilliseconds && givenDateMilliseconds <= endOfWeekMilliseconds                
            },

            isSameMonth ( date ) {
                const givenDate = new Date(date).toISOString().split('T')[0]
                const now = new Date().toISOString().split('T')[0]

                const givenDateFullYear = givenDate.split('-')[0]
                const givenDateMonth = givenDate.split('-')[1]
                
                const nowFullYear = now.split('-')[0]
                const nowMonth = now.split('-')[1]

                return givenDateFullYear === nowFullYear && givenDateMonth === nowMonth
            },

            removeDuplicates ( arr ) {
                return [...new Map(arr.map(item => [JSON.stringify(item), item])).values()]
            },

            getTasks: async function () {
                try {  
                    const user_tasks_rs = await axios.post(`${appUrls.api}/api/admin/tasks`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        status_filters: this.effectiveStatuses,
                        completed_from: this.filterby.completed_only && this.filterby.completed_date_range.length === 2 ? [...this.filterby.completed_date_range].sort()[0] : undefined,
                        completed_to: this.filterby.completed_only && this.filterby.completed_date_range.length === 2 ? [...this.filterby.completed_date_range].sort()[1] : undefined
                    })

                    if ( user_tasks_rs.data.outcome ) {
                        this.searched_status_filters = user_tasks_rs.data.status_filters
                        // PREPARE THE TASKS AS PLAIN OBJECTS FIRST, THEN HAND VUE FROZEN COPIES (SEE BELOW)
                        const tasks = user_tasks_rs.data.tasks || []

                        // THE SERVER FILLS IN THE DEFAULT RANGE & CAPS VERY LARGE RANGES
                        const completed = user_tasks_rs.data.completed || {}
                        if ( this.filterby.completed_only && completed.completed_from && completed.completed_to ) {
                            this.filterby.completed_date_range = [completed.completed_from, completed.completed_to]
                        }
                        this.completed_info = {
                            truncated: completed.truncated === true,
                            completed_total: completed.completed_total || 0,
                            shown: tasks.filter(task => task.status === 'completed').length
                        }

                        let i = 0;
                        for( let task of tasks ) {
                            // PROJECT TITLE & INTERNAL TITLE
                            const internal_title = task.internal_project_title != null ? task.internal_project_title : ''
                            const user_prj_title = task.project_title != null ? task.project_title : ''
                            const mod_divider    = internal_title != '' || user_prj_title != '' ? ' :: ' : ': '
                            const title_divider  = internal_title != '' && user_prj_title != '' ? ' :: ' : ''
                            task.project_label = `
                                <span class="font-weight-bold grey--text text--darken-1">${task.module_name}</span><br>
                                <span class="font-weight-thin grey--text">${internal_title}</span>
                                <span class="font-weight-thin grey--text text--darken-2">${title_divider}${user_prj_title}</span>`

                            const sortedUsers = task.client_info.sort((a, b) => {
                                const aIndex = this.users_sortorder.indexOf(a.user_type);
                                const bIndex = this.users_sortorder.indexOf(b.user_type);
                                return aIndex - bIndex;
                            });
                            task.client_info_stringified = JSON.stringify(sortedUsers)
                           
                            task.due_date_label = this.isPastDue(task.date) && !['completed', 'not_applicable'].includes(task.status) ? `<span class="error--text">${this.formatThisDate(task.date)}</span>` : this.formatThisDate(task.date)

                            this.projectStatusData.find( status => {
                                if ( status.value == task.project_status ) {
                                    task.project_status_label = status.internal_label
                                    task.project_status_text_color = status.status_text_color
                                }
                            })

                            const taskOwnerName = this.ownerArray.find(owner => owner.value == task.owner_id)
                            task.owner_name = taskOwnerName ? taskOwnerName.text : ''

                            switch ( task.complexity ) {
                                case 'low':     task.complexity_val = 1; break;
                                case 'medium':  task.complexity_val = 2; break;
                                case 'high':    task.complexity_val = 3; break;
                                default:        task.complexity_val = 0; break;
                            }
                            
                            i++;
                        }
                        // FROZEN TASKS AREN'T MADE DEEPLY REACTIVE, WHICH IS MOST OF THE COST OF LOADING THOUSANDS OF THEM.
                        // SAFE BECAUSE NOTHING EDITS A LOADED TASK IN PLACE: THE EDIT DRAWER GETS A COPY & SAVING RE-PULLS THE LIST
                        this.tasks = Object.freeze(tasks.map(task => Object.freeze(task)))
                        // console.log(this.tasks)
                        this.filterTasks();
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            openTaskDetails: function ( task ) {
                this.this_userId = task.user_id
                this.this_projectId = task.project_id
                this.this_clientInfo = task.client_info
                this.projectDataDialog = true
            },

            closeDetailDialog: function () {
                this.projectDataDialog = false
                this.this_userId = ''
                this.this_projectId = ''
                this.this_clientInfo = []
                this.getTasks()
            },

            openTaskDetailsDialog(item) {
                this.editedItem = {
                    ...item
                };
                // this.$refs.projectReportDialog.open();
                this.projectTaskDialog = true
            },

            close () {
                this.projectTaskDialog = false
                setTimeout(() => {
                    this.editedItem = {};
                }, 300);
            },

            async save () {
                this.getTasks()
            },

            async loadNextTask ( nextTask ) {
                if ( !nextTask || !nextTask.task_id ) {
                    this.projectTaskDialog = false
                    this.getTasks()
                    return
                }

                this.editedItem = {
                    ...nextTask
                }
                this.projectTaskDialog = true
                this.getTasks()
            },

            applyCompletedDateRange () {
                this.filterby.completed_date_range = [...this.completedDateRangeDraft].sort()
                this.completedDateRangeMenu = false
                this.toggleCompletedOnly()
            },

            // SWITCHING BETWEEN OPEN & COMPLETED TASKS PULLS A DIFFERENT SET FROM THE API
            toggleCompletedOnly () {
                localStorage.setItem('taskDashboardFilters', JSON.stringify(this.filterby))
                this.table_loading = true
                this.tasks = []
                this.filteredTasks = []
                this.filtered_tasks_cnt = 0
                this.getTasks()
            },

            filterTasks() {                
                let filteredTasks = this.tasks

                if ( this.filterby.module.length ) {
                    let module_dataset = [].concat.apply([], this.filterby.module)

                    filteredTasks = filteredTasks.reduce( (tasks, task) => {
                        if ( module_dataset.includes(task.module_key) ) {
                            tasks.push(task)
                        }
                        return tasks
                    }, [])
                }

                // let levels_data_set = this.filterby.service_levels.length ? filteredTasks : this.tasks
                // if ( this.filterby.service_levels.length ) {
                //     let service_levels_dataset = [].concat.apply([], this.filterby.service_levels)

                //     filteredTasks = filteredTasks.reduce( (tasks, task) => {
                //         // filter tasks that are not of the level set type
                //         if (
                //             task.module_key === 'entity-maintenance-program' || 
                //             task.module_key === 'seller-advocacy' || 
                //             task.module_key === 'succession' || 
                //             task.module_key === 'deal-support' || 
                //             task.module_key === 'merger' || 
                //             task.module_key === 'entity' || 
                //             task.module_key === 'core-value' || task.module_key === 'practice-value' || task.module_key === 'enterprise-value' || 
                //             task.module_key === 'equity' || 
                //             task.module_key === 'hr-solutions-employment-agreements' || task.module_key === 'hr-solutions-comp-design' || task.module_key === 'hr-solutions-comp-tsr' || 
                //             task.module_key === 'contingency'
                //         ) {
                //             tasks.push(task)
                //         }
                //         service_levels_dataset.forEach( text => {
                //             if ( task.module_key.indexOf(text) != -1 ) {
                //                 tasks.push(task)
                //             }
                //         })
                //         return tasks
                //     }, [])
                // }

                if ( this.filterby.due_date.length ) {
                    let due_date_dataset = [].concat.apply([], this.filterby.due_date)

                    filteredTasks = filteredTasks.reduce( (tasks, task) => {
                        due_date_dataset.forEach( val => {
                            // const targetDate = new Date(task.date);
                            const targetDate = task.date;
                            
                            if ( val === 'past_due' && this.isPastDue( targetDate ) ) {
                                tasks.push(task)
                            } else if ( val === 'due_today' && this.isToday( targetDate ) ) {
                                tasks.push(task)
                            } else if ( val === 'due_tomorrow' && this.isTomorrow( targetDate ) ) {
                                tasks.push(task)
                            } else if ( val === 'due_this_week' && this.isInSameWeek( targetDate ) ) {
                                tasks.push(task)
                            } else if ( val === 'due_this_month' && this.isSameMonth( targetDate ) ) {
                                tasks.push(task)
                            }
                        })
                        return tasks
                    }, [])

                    filteredTasks = this.removeDuplicates(filteredTasks)
                }

                // let status_data_set = filteredTasks.length ? filteredTasks : this.tasks
                if ( this.effectiveStatuses.length ) {              
                    let status_dataset = [].concat.apply([], this.effectiveStatuses)
      
                    filteredTasks = filteredTasks.reduce( (tasks, task) => {
                        // let this_status = prj.status.startsWith('hold') ? 'hold' : prj.status
                        if ( status_dataset.includes(task.status) ) {
                            tasks.push(task)
                        }
                        return tasks
                    }, [])
                }

                if (this.filterby.priority.length) {
                    let priority_dataset = [].concat.apply([], this.filterby.priority)

                    filteredTasks = filteredTasks.filter(task => priority_dataset.includes(task.priority));
                }

                if (this.filterby.owner.length) {
                    let owner_dataset = [].concat.apply([], this.filterby.owner)

                    filteredTasks = filteredTasks.filter(task => owner_dataset.includes(task.owner_id));
                }

                // let projectstatus_data_set = filteredTasks.length ? filteredTasks : this.tasks
                if ( this.filterby.project_status.length ) {              
                    let projectstatus_data_set = [].concat.apply([], this.filterby.project_status)
      
                    filteredTasks = filteredTasks.reduce( (tasks, task) => {
                        // let this_status = prj.status.startsWith('hold') ? 'hold' : prj.status
                        if ( projectstatus_data_set.includes(task.project_status) ) {
                            tasks.push(task)
                        }
                        return tasks
                    }, [])
                }

                if (this.filterby.search) {
                    const searchLower = this.filterby.search.toLowerCase();
                    filteredTasks = filteredTasks.filter(task => {
                        return task.label.toLowerCase().includes(searchLower) || 
                            task.project_label.toLowerCase().includes(searchLower) ||
                            task.client_info_stringified.toLowerCase().includes(searchLower);
                    });
                }

                this.filteredTasks = filteredTasks;
                this.filtered_tasks_cnt = filteredTasks.length;
                
                localStorage.setItem('taskDashboardFilters', JSON.stringify(this.filterby));
                this.table_loading = false;
            },

            onUpdateOptions(newOptions) {
                this.options = newOptions;
                localStorage.setItem('taskDashboardOptions', JSON.stringify(newOptions));
            },
        },
    }
</script>

<style scoped>
    .filter-container {
        position: sticky;
        top: 0;
        background-color: white;
        z-index: 1000;
        padding-top: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    .psr_avenir_book {
        font-size: 1.05em !important;
        font-family: 'AvenirBook' !important;
    }
    .v-dialog__content {
        width: 98vw !important;
    }
    #tasks_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 3rem 0 0 0;
        display: flex;
        flex-direction: column;
        height: 100vh; /* ensure wrapper fills viewport */
        z-index: 0;
    }
    .header_bg_color {
        background-color: var(--v-primary-darken3)
    }
    .custom-table >>> .v-data-table-header th:nth-child(1) {
        padding-left: .2em !important;
    }
    .custom-table >>> .v-data-table-header th:nth-child(3) {
        /* border-left: 1px solid #E9EAEC !important; */
        border-left: 2px solid #007b8b !important;
        padding-left: .3em !important;
    }
    .custom-table >>> .v-data-table-header th:nth-child(4) {
        padding-right: 1.4em !important;
    }
    /* td.edge-padding-left {
        padding-left: .2em !important;
    } */
    /* td.edge-padding-right {
        padding-right: .4em !important;
    } */
    .left-border-cell {
        /* border-left: 1px solid #E9EAEC; */
        border-left: 2px solid #007b8b
    }
    .task_data_class {
        padding: 9px 0 !important;
        margin: 0 !important;
        vertical-align: top !important;
        font-family: 'AvenirBook' !important;
    }

    thead {
        position: sticky;
        top: 0;
        background-color: white; /* Ensure the background color matches the table */
        z-index: 1; /* Ensure the header is above the table rows */
    }
    /* tr:nth-of-type(odd) {
        background-color: rgba(223, 233, 236, .25);
    }
    tr:nth-of-type(even) {
        background-color: rgba(0, 0, 0, .05);
    } */
    tr:nth-of-type(odd) {
        /* background-color: rgba(223, 233, 236, .25); */
    }
    tr:nth-of-type(even) {
        background-color: rgba(223, 233, 236, .25);
        /* background-color: rgba(0, 0, 0, .05); */
        /* background-color: rgba(226, 249, 253, 0.45); */
    }
 >>> tbody tr {
        cursor: pointer !important;
    }
    td.no_extra_border {
        border-bottom: 0 !important;
    }
    .v-data-table { 
        overflow-x: auto;
    }
    .title {
        padding: .5em;
    }
    #new_btn {
        width: 100%;
        text-align: right;
    }
    .dialog_title_bkg {
        background-color: #2196f3; /* #17a2b8 */
        color: #fff
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .v-expansion-panel-header.v-expansion-panel-header {
        padding: 1em !important;
        margin: 0 !important;
    }
    .v-expansion-panel-header.v-expansion-panel-header--active,
    .v-expansion-panel-header.v-expansion-panel-header:hover {
        background: #eef7f8;
        padding: 1em !important;
        margin: 0 !important;
        /* background-color: rgba(189, 235, 249, 0.25); */
    }
 >>> .v-expansion-panel-content__wrap {
        padding: .5em 0 !important; 
        /* margin: 0 !important;     */
    }
 >>> .v-data-table { 
        overflow-x: scroll !important;
        overflow-y: scroll !important;
    }
 >>> .v-data-table .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 1em 0 0 !important;
        font-size: x-small;
        color: #333 !important;
        margin: 0 !important;
        height: 36px !important;
        border-top: 1px solid #EDEDED !important;
    }
    .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
        padding: .8em 0 .8em 0 !important;
        margin: 0 !important;
        font-size: small;
        /* border: 1px solid blue !important; */
    }
 >>> .v-data-table__expanded {
        background-color: #fff !important;
        padding: .8em 1em .8em 1em !important;
        height: 90px !important;
    }
    .v-data-table { 
        overflow-x: auto !important;
    }
    .v-data-table__wrapper {
        overflow-x: auto !important;
    }
    .text-underline {
        text-decoration: underline;
    }
    .fade-out-btn {
        transition: opacity 0.5s ease-out; /* Smooth fade-out transition */
    }
    .fade-out-btn[v-cloak] {
        display: none; /* Prevent flash before Vue mounts */
    }
    .fade-out-btn:not([v-show]) {
        opacity: 0; /* Fade out when hidden */
    }
    .align-text-top {
       vertical-align: top;
    }
    .drawer-shadow {
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        height: 100vh !important;
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/TaskDashboard.vue